import { render, staticRenderFns } from "./form1.vue?vue&type=template&id=13ac7844&"
import script from "./form1.vue?vue&type=script&lang=js&"
export * from "./form1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports